@if (!isAdminRoute) {
<div class="menu-mobile" [ngClass]="{
  'hidden': isMobileMenuHidden
}">
    <div class="menu-close" (click)="toggleMobileMenu()" aria-label="Sluit menu">
      <icon name="close" class="close-icon"></icon>
    </div>
    <div class="menu-item-container">
      @for (menuItem of menuItems; track menuItem) {
        <div class="menu-item" (click)="navigateTo(menuItem, true)">{{menuItem}}</div>
      }
      <div class="menu-item" (click)="signIn()">Login</div>
    </div>
    <div class="line"></div>
    <div class="socials">
      <icon name="facebook" (click)="redirectTo('facebook')"></icon>
      <!-- <icon name="twitter"  (click)="redirectTo('twitter')"></icon> -->
      <icon name="linkedin" (click)="redirectTo('linkedin')"></icon>
      <icon name="instagram" class="insta"  (click)="redirectTo('instagram')"></icon>
    </div>
  </div>
}

<div #transitionRef class="top-container">
  @if (!isAdminRoute) {
    <div class="header-container" [ngClass]="{'header-hidden': sharedService.isMobileMenuButtonHidden}">
      <div class="header">
        <div class="header-logo" (click)="navigateTo('home')">
          <icon name="blauwtand"></icon>
        </div>
        @for (menuItem of menuItems; track menuItem; let i = $index) {
          <div class="header-menu-items" (click)="navigateTo(menuItem)">
            <div class="header-menu-item">
              <button class="header-button">
                <span>{{menuItem}}</span>
              </button>
              @if (i !== menuItems.length -1) {
                <div class="header-menu-item-divider"></div>
              }
            </div>
          </div>
        }
        <div class="header-menu-item-divider"></div>
        <button class="header-sign-in" (click)="signIn()">Login</button>
        <div class="header-menu-mobile" (click)="toggleMobileMenu()">
          <div [ngClass]="{'hidden': !isMobileMenuHidden}">
            <icon name="menu"></icon>
          </div>
        </div>
      </div>
      <app-breadcrumbs></app-breadcrumbs>
    </div>
  }
  <router-outlet class="content"></router-outlet>
  @if (!isAdminRoute) {
    <footer class="footer"></footer>
  }
  @if (!isAdminRoute) {
    <app-public-shadcn-toaster></app-public-shadcn-toaster>
  }

  <!-- <div class="cookie-consent" [ngClass]="{'hidden': hasCookieConsent}">
  <div class="cookie-text">
    <span class="cookie-hover right" (click)="navigateHome()">Blauwtand.com</span>
    <span>gebruikt cookies om de noodzakelijke websitefunctionaliteit te bieden en uw ervaring te verbeteren. Door de website te gebruiken, gaat u akkoord met onze</span>
    <span class="cookie-hover both" (click)="navigatePrivacyStatement()">privacy statement</span>
    <span>en het gebruik van</span>
    <span class="cookie-hover left" (click)="cookiesReadMore()">cookies</span>
    <span>.</span>
  </div>
  <div class="cookie-buttons">
    <button mat-raised-button color="primary" class="cookie-button-accept" (click)="setCookieConsent('true')">
      <span>Accepteren</span>
      <icon name="done"></icon>
    </button>
    <button mat-raised-button color="primary" class="secondary-button" (click)="setCookieConsent('false')">
      <span>Afwijzen</span>
      <icon name="close"></icon>
    </button>
  </div>
</div> -->
